import type { CurrentUser } from "@/modules/user/api/types"

import { OTHER_SCHOOL_ID } from "@/modules/jobAds/client/constants"

/**
 * We are disabling the possibility to filter by abroad if the user is from the school "Other" which
 * is represented as any other school with a given ID.
 */
export function isAbroadOptionEnabledForCurrentUser(currentUser?: CurrentUser): boolean {
  const userHasCountry = !!currentUser?.attributes.country
  const userHasSchool = !!currentUser?.attributes.schoolId
  const userSchoolIsKnown = currentUser?.attributes.schoolId !== OTHER_SCHOOL_ID
  const enableAbroadOption = userHasCountry && userHasSchool && userSchoolIsKnown

  return enableAbroadOption
}
